import React from "react";
import Filters from "../components/form/Filters";
const BotFilters = (props) => <Filters {...props} />;
export default BotFilters;
